__turbopack_context__.v({
  "accordionContainer": "CategoryLinkAccordion-module-scss-module__O4t0zq__accordionContainer",
  "categoryLink": "CategoryLinkAccordion-module-scss-module__O4t0zq__categoryLink",
});
